export enum ErrorMessage {
  NO_OK_SUGGEST_RESPONSE = "Did not receive status code 200",
  EMPTY_SUGGESTIONS = "No suggestions to show",
  KEYWORDS_UNDEFINED = "Keywords are undefined!",
}

export enum TRACK_LABEL {
  WK_SUGGEST_TIME = "wk.san_SuggestTime",
  WK_SEARCH_TYPE = "wk.san_SearchType",
  WK_FALLBACK = "wk.san_Fallback",
  WK_COUNT_HITS = "wk.san_CountHits",
  WK_SEARCH_TERM = "wk.san_SearchTerm",
  WK_SEARCH_WORD_COUNT = "wk.san_SearchWordCount",
  WK_EMPTY_STATE_TIME = "wk.san_EmptyStateTime",
  WK_EMPTY_STATE_COUNT = "wk.san_EmptyStateCount",
  WK_INITIAL_SEARCHBOX_TIME = "wk.san_InitialSearchBoxTime",
  WK_SUGGEST_POS = "wk.san_SuggestPos",
  WK_SEARCH_HISTORY = "wk.san_SearchHistory",
  WK_ACTIVE_SEARCH = "wk.san_ActiveSearch",
  WK_SUGGEST_SEARCH_TERM = "wk.san_SuggestSearchTerm",
  WK_SUGGEST_METHOD = "wk.san_SuggestMethod",

  SQUIRREL_SESSION_START = "san_SquirrelSessionStart",
  PAGELOAD_COMPLETE = "san_PageLoadComplete",
  SUGGEST_RENDER_TIME = "san_SuggestRenderTime",
  TARGET_URL_FALLBACK = "san_TargetUrlResponseFallback",
  SEARCH_BOX_ACTION = "san_SearchBoxAction",
  SUGGEST_ADOPT_TERM = "san_SuggestAdoptTerm",
  SUGGEST_ADOPT_POSITION = "san_SuggestAdoptPosition",
  INITIAL_SEARCH = "san_InitialSearch",
  INTERACTION = "san_Interaction",
  SORTING_CHANGE = "san_SortingChange",
  SUGGEST_LIST_WORD_COUNT = "san_SuggestListWordCount",
  SUGGEST_LIST = "san_SuggestList",
  SUGGEST_POS = "san_SuggestPos",
  SUGGEST_SEARCH_TERM = "san_SuggestSearchTerm",
  SUGGEST_SEARCH_TERM_LENGTH = "san_SuggestSearchTermLength",
  SEARCH_HISTORY = "san_SearchHistory",
  SUGGEST_METHOD_ACTION = "san_SuggestMethodAction",
}

export enum INTERACTION {
  SORT_CHANGE = "sorting_change",
  INITIAL_SEARCH = "initial_search",
}

export enum SAN_SEARCH_TYPE {
  SEARCH = "search",
  HISTORY = "history",
  TRENDING_QUERY = "trending_queries",
  SUGGEST = "suggest",
  MODIFIED = "modified",
  NONE = "",
}

export enum SEMANTIC_TRACKING_VALUE {
  SEMANTIC = "semantic",
}

export const SEMANTIC_TRACKING_STRING = `${TRACK_LABEL.WK_SUGGEST_METHOD}%22%3A%22${SEMANTIC_TRACKING_VALUE.SEMANTIC}`;

export const FALLBACK_SEARCH_URL = (
  term: string,
  additionalLabels: object = { [TRACK_LABEL.TARGET_URL_FALLBACK]: "true" },
): string => {
  const trackingData = Object.assign(
    {
      [TRACK_LABEL.WK_SEARCH_TYPE]: SAN_SEARCH_TYPE.SEARCH,
      [TRACK_LABEL.WK_ACTIVE_SEARCH]: "true",
      [TRACK_LABEL.INITIAL_SEARCH]: "true",
      [TRACK_LABEL.INTERACTION]: INTERACTION.INITIAL_SEARCH,
    },
    additionalLabels,
  );

  const ref = `#t=${encodeURIComponent(JSON.stringify(trackingData))}`;
  const encodedTerm = encodeURIComponent(term);
  return `https:/*                                                  */
};

export enum STORAGE_ITEM {
  HISTORICAL_DATA = "squirrelHistoricalData",
  SEARCH_TRACKING = "squirrel_searchTracking",
}

export enum HISTORY_MODE {
  SELECT = "select",
  NORMAL = "normal",
}

export enum ELEMENT_EVENT {
  CLICK = "click",
  FOCUS = "focus",
  FOCUS_OUT = "focusout",
  KEY_DOWN = "keydown",
  BLUR = "blur",
  INPUT = "input",
  KEY_UP = "keyup",
  RESET = "reset",
  SUBMIT = "submit",
}

export enum ELEMENT {
  LI = "li",
  UL = "ul",
  INPUT = "input",
}
